var icon = 'qw5m0k1';
var trigger = 'qw5m0k0';

export { icon, trigger };
//# sourceMappingURL=scrubbable-input.css.js.map
